import {normalize, schema} from "normalizr";

class UserConverter {
  
  fromAPIUsersResponse(usersResp) {
    
    const localUser = usersResp.map(user => {
      return this.fromAPIUser(user);
    });
    
    const usersEntity = new schema.Entity('users');
    const userSchema = [usersEntity];
    const normalizedData = normalize(localUser, userSchema);
    
    console.info('[UserConverter.fromAPIUser] converted users: ', normalizedData.entities.users);
    
    return normalizedData.entities.users;
  }
  
  
  fromAPIUser(response) {
    
    let params = {};
    params.id = response.id;
    params.username = response.time;
    params.firstName = response.time;
    params.lastName = response.time;
    params.email = response.time;
    params.role = response.time;
    
    return params;
  }
  
  toAPIRegisterUSer(response) {
  
    let params = {};
    params.firstName = response.firstName;
    params.lastName = response.lastName;
    params.email = response.email;
    params.password = response.password;

    return params;
  }
  
  
  
}

export default new UserConverter();


// WEBPACK FOOTER //
// ./src/models/user/userConverter.js